/**
 * Application Configuration
 * Auto-detects backend URL based on environment
 */

export const getBackendURL = () => {
  const currentDomain = window.location.hostname;
  
  // Use configured backend URL from environment variables
  const envBackendUrl = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;
  
  // If env variable exists, use it
  if (envBackendUrl) {
    return envBackendUrl;
  }
  
  // Fallback to same origin (for deployments without explicit backend URL)
  // This allows the app to work on any domain (Emergent deployments, custom domains, etc.)
  return window.location.origin;
};

export const BACKEND_URL = getBackendURL();

// Log the detected backend URL for debugging
console.log('🔧 Backend URL detected:', BACKEND_URL);
